
import FormItem from "@/components/DocumentViewCards/views/Card/components/forms/FormItem.vue";
import { IPTEForm } from "@/models/PTE";
import { TInputRule } from "@nationbetter/nb-components/src/models/Input";
import { Component, Prop, Vue } from "vue-property-decorator";

const FORM_MODEL = {
  date: "",
  family_name: "",
  first_name: "",
  listening: "",
  reading: "",
  speaking: "",
  selt_urn: "",
  writing: "",
};

@Component({
  components: { FormItem },
})
export default class FormIELTS extends Vue {
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;
  @Prop({ type: Object, required: true }) readonly details!: any;

  confirm() {
    this.$emit("confirm", this.form);
  }

  created() {
    this.setCosForm(this.details);
  }

  setCosForm(data: IPTEForm) {
    Object.assign(this.form, { ...data });
  }

  form: IPTEForm = FORM_MODEL;

  minDate = "years:2";

  get formInvalid() {
    return false;

    // TODO: uncomment once Anna has done her thing

    // const { listening, reading, writing, speaking, date } = this.form;

    // const scores = [listening, reading, writing, speaking];

    // const isDateValid = this.dateRules.some((rule) => rule(date) === true);

    // return (
    //   Object.values(this.form).includes("") ||
    //   scores.some((score) => Number(score) < 59) ||
    //   !isDateValid
    // );
  }

  requiredRules = [(v: string) => v.length || this.$tc("errors.noValue")];

  scoreRules: TInputRule[] = [
    (v) => !!v.length || this.$tc("errors.noValue"),
    (v) => Number(v) >= 59 || this.$tc("errors.score"),
  ];

  dateRules = [
    (value: string) => {
      const parts = value.split("/").map((part) => parseInt(part));

      const date = new Date(parts[2], parts[1] - 1, parts[0]);

      if (this.minDateComputed && this.minDateComputed > date) return this.$tc("errors.date");

      return true;
    },
  ];

  createMinDate(days: number, months: number, years: number) {
    const date = new Date();

    date.setDate(date.getDate() - days);
    date.setMonth(date.getMonth() - months);
    date.setFullYear(date.getFullYear() - years);

    return date;
  }

  get minDateComputed() {
    if (!this.minDate) return null;

    const { days, months, years } = Object.fromEntries(
      this.minDate.split(/, */).map((s) => s.split(/: */))
    );

    return this.createMinDate(Number(days) || 0, Number(months) || 0, Number(years) || 0);
  }
}
